/**
 * Object/array helpers.
 * Replaces caribe7/lib/helpers/object-array-helper.js.
 */

/**
 * Flatten an object so nested keys become "key.nestedKey".
 * Arrays are kept as-is (not expanded).
 */
export function flattenObj(ob: Record<string, unknown>): Record<string, unknown> {
  const result: Record<string, unknown> = {};
  for (const i in ob) {
    if (Object.prototype.hasOwnProperty.call(ob, i)) {
      const val = ob[i];
      if (typeof val === 'object' && val !== null && !Array.isArray(val)) {
        const temp = flattenObj(val as Record<string, unknown>);
        for (const j in temp) {
          if (Object.prototype.hasOwnProperty.call(temp, j)) {
            result[i + '.' + j] = temp[j];
          }
        }
      } else {
        result[i] = val;
      }
    }
  }
  return result;
}
